import { render, staticRenderFns } from "./PayGateSetting.vue?vue&type=template&id=9cec06b4"
import script from "./PayGateSetting.vue?vue&type=script&lang=js"
export * from "./PayGateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports